import React from 'react';
import { Container } from '../components/Container';
export function Wholesale() {
  return <div className="w-full bg-white pb-20" data-id="element-856">
      {/* Header */}
      <div className="bg-[#111827] text-white py-16" data-id="element-857">
        <Container data-id="element-858">
          <div className="max-w-3xl" data-id="element-859">
            <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-860">
              Interested in Wholesale?
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-861"></div>
            <p className="text-xl text-gray-300" data-id="element-862">
              Have a business, resale opportunity, teamwear program, or
              wholesale uniform need? Tell us about your business and our team
              will help determine the best path for your account.
            </p>
          </div>
        </Container>
      </div>

      <Container className="py-16" data-id="element-863">
        <div className="max-w-3xl mx-auto" data-id="element-864">
          <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-865">
            Primetime Sports Apparel works with teams, organizations, and
            business buyers who need custom uniform programs, repeat ordering
            support, and factory-direct production options. If you are
            interested in wholesale, complete the form below and our team will
            follow up.
          </p>

          <form className="space-y-6 bg-gray-50 p-8 rounded-xl border border-gray-200" onSubmit={e => e.preventDefault()} data-id="element-866">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-867">
              <div data-id="element-868">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-869">
                  Name *
                </label>
                <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-870" />
              </div>
              <div data-id="element-871">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-872">
                  Email *
                </label>
                <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-873" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-874">
              <div data-id="element-875">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-876">
                  Phone
                </label>
                <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-877" />
              </div>
              <div data-id="element-878">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-879">
                  Business / Organization Name *
                </label>
                <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-880" />
              </div>
            </div>

            <div data-id="element-881">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-882">
                Website (if applicable)
              </label>
              <input type="url" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-883" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-884">
              <div data-id="element-885">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-886">
                  What best describes you?
                </label>
                <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-887">
                  <option data-id="element-888">Select an option</option>
                  <option data-id="element-889">Dealer</option>
                  <option data-id="element-890">Reseller</option>
                  <option data-id="element-891">Decorator</option>
                  <option data-id="element-892">Team Store Operator</option>
                  <option data-id="element-893">League or Organization</option>
                  <option data-id="element-894">School</option>
                  <option data-id="element-895">Other</option>
                </select>
              </div>
              <div data-id="element-896">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-897">
                  Are you interested in wholesale?
                </label>
                <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-898">
                  <option data-id="element-899">Yes</option>
                  <option data-id="element-900">Not sure</option>
                </select>
              </div>
            </div>

            <div data-id="element-901">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-902">
                What products or sports are you interested in?
              </label>
              <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-903" />
            </div>

            <div data-id="element-904">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-905">
                Estimated monthly or seasonal order volume
              </label>
              <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-906" />
            </div>

            <div data-id="element-907">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-908">
                Message
              </label>
              <textarea rows={4} className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white resize-none" data-id="element-909"></textarea>
            </div>

            <div className="pt-4" data-id="element-910">
              <button type="submit" className="bg-pts-red hover:bg-pts-red-dark text-white px-8 py-3 rounded font-bold uppercase tracking-wide transition-colors w-full sm:w-auto" data-id="element-911">
                Request Wholesale Info
              </button>
            </div>
          </form>
        </div>
      </Container>
    </div>;
}